import React from 'react';
import { IApproachProps } from './interface';
import { RichText } from 'prismic-reactjs';
import {
  Approach,
  ApproachDescription,
  Approaches,
  ApproachText,
  Inner,
  Title,
  Wrapper,
} from './ourApproach.styles';

export const OurApproach = ({
  title,
  approaches,
  titleAs,
}: IApproachProps): JSX.Element => {
  return (
    <Wrapper>
      <Inner>
        <Title as={titleAs}>{title}</Title>
        <Approaches>
          {approaches.map(({ title, description }, index) => {
            return (
              <Approach key={index}>
                <ApproachText>{RichText.asText(title)}</ApproachText>
                <ApproachDescription>
                  {RichText.asText(description)}
                </ApproachDescription>
              </Approach>
            );
          })}
        </Approaches>
      </Inner>
    </Wrapper>
  );
};
